export default {
  title: 'Colofon',
  subtitle: 'Verschijnt pas na opslaan in de footer van je webshop en website.',
  card_title: 'Colofon',
  placeholder: 'Vul je colofongegevens in',
  status: {
    saved: 'Opgeslagen',
    not_shown: 'Nog niet zichtbaar in je webshop of op je website',
    unsaved: 'Niet-opgeslagen wijzigingen — je webshop en website tonen de laatst opgeslagen versie',
  },
  save: 'Opslaan',
  retry: 'Opnieuw proberen',
  preview: {
    title: 'Voorbeeld van de footer (webshop en website)',
    terms: 'Voorwaarden',
    privacy: 'Privacy',
    cookies: 'Cookies',
    imprint: 'Colofon',
  },
  toasts: {
    saved: 'Colofon opgeslagen',
    save_failed: 'Het colofon kon niet worden opgeslagen. Probeer het opnieuw.',
    load_failed: 'Het colofon kon niet worden geladen. Laad de pagina opnieuw.',
  },
};
